/* =============================================================
   TYRE DISPATCH - GUIDE CARDS
   Theme asset. Safe to load on every page: each block looks for
   its own card and does nothing if it is not there. Each one
   loops over every copy of its card, so a card may appear more
   than once on a page.
   ============================================================= */

/* ---------- make every card safe to use more than once on a page ----------
   The card artwork carries SVG ids -- clipPaths, gradients, masks. Those are
   fine once and wrong twice: url(#id) resolves to the FIRST match in the
   document, so a second copy of a card silently borrows the first one's
   defs, and two different cards that happen to share an id prefix do the same.
   The wet and beach cards both ship tdsuv-* for exactly that reason.

   Identical defs made it invisible. It stops being invisible the moment a card
   is reused in a different colour, or a page shows the same card twice. So
   every card gets its ids namespaced on the way in, and every reference to
   them rewritten to match. Runs first, before anything else looks at the DOM. */
(function(){
  var seq = 0;
  function reid(root, tag){
    var ided = root.querySelectorAll("[id]");
    if(!ided.length) return;
    var all = root.querySelectorAll("*"), i, j, k;
    for(i = 0; i < ided.length; i++){
      var was = ided[i].id, now = was + "-" + tag;
      ided[i].id = now;
      for(j = 0; j < all.length; j++){
        var at = all[j].attributes;
        for(k = 0; k < at.length; k++){
          if(at[k].value === "url(#" + was + ")") at[k].value = "url(#" + now + ")";
          else if(at[k].value === "#" + was) at[k].value = "#" + now;
        }
      }
    }
  }
  [].forEach.call(document.querySelectorAll(".td-gcard"), function(card){
    reid(card, "i" + (++seq));
  });
})();

/* ---------- Speed Rating: needle, letter and number step together ---------- */
(function(){
  /* one per card root, so the card can appear more than once */
  [].forEach.call(document.querySelectorAll(".td-spd-vis"), function(root){
    var SPEEDS=[["L",120],["Q",160],["T",190],["H",210],["V",240],["W",270],["Y",300]];
    var dial=root.querySelector(".td-spd-dial"), nd=root.querySelector(".td-spd-nd"),
        L=root.querySelector(".td-spd-spL"), N=root.querySelector(".td-spd-spN");
    if(!dial) return;
    for(var s=60;s<=310;s+=10){
      var t=document.createElement("i");
      t.className="td-spd-tk"+(s%50===0?" td-spd-maj":"");
      t.style.transform="rotate("+(s-180)+"deg)"; dial.appendChild(t);
    }
    var si=4;
    (function step(){
      var p=SPEEDS[si];
      nd.style.transform="rotate("+(p[1]-180)+"deg)";
      L.textContent=p[0]; N.textContent=p[1];
      si=(si+1)%SPEEDS.length; setTimeout(step,1400);
    })();
  });
})();

/* ---------- Load Rating: real index to kilogram pairs ---------- */
(function(){
  /* one per card root, so the card can appear more than once */
  [].forEach.call(document.querySelectorAll(".td-load-vis"), function(root){
    var LOADS=[[62,265],[75,387],[82,475],[91,615],[94,670],[104,900],[112,1120],[126,1700]];
    var I=root.querySelector(".td-load-ldI"), K=root.querySelector(".td-load-ldK");
    if(!I) return;
    var li=4;
    setInterval(function(){
      li=(li+1)%LOADS.length;
      I.textContent=LOADS[li][0]; K.textContent=LOADS[li][1];
    },1100);
  });
})();

/* ---------- WOF sticker: month AND year off the clock ---------- */
(function(){
  /* one per card root, so the card can appear more than once */
  [].forEach.call(document.querySelectorAll(".td-wof-vis"), function(root){
    var NOW=new Date(), M=NOW.getMonth()+1, Y=NOW.getFullYear()%100;
    [["td-wof-ml",1],["td-wof-mr",7]].forEach(function(pair){
      var box=root.querySelector("."+pair[0]); if(!box) return;
      for(var m=pair[1];m<pair[1]+6;m++){
        var i=document.createElement("i");
        i.textContent=m; if(m===M) i.className="td-wof-on";
        box.appendChild(i);
      }
    });
    var yrs=root.querySelector(".td-wof-yrs");
    if(yrs) yrs.innerHTML=[0,1,2,3].map(function(o){
      return '<b class="'+(o===0?"td-wof-on":"")+'">'+String((Y+o)%100).padStart(2,"0")+'</b>';
    }).join("");
  });
})();

/* ---------- Tread striker: bands, names, and the bar climbing ---------- */
(function(){
  /* one per card root, so the card can appear more than once */
  [].forEach.call(document.querySelectorAll(".td-tw-scene"), function(root){
    var BANDS=[[0,.7,"DANGEROUS","#a01226"],[.7,1.5,"BELOW LIMIT","#d4162f"],
      [1.5,2.4,"REPLACE NOW","#e8622c"],[2.4,3.3,"LOW","#f2921f"],
      [3.3,4.3,"OKAY","#ecc821"],[4.3,5.5,"GOOD","#b0cc2c"],
      [5.5,6.8,"HIGH","#55b03c"],[6.8,8,"NEW","#1fa85a"]];
    var TOP=8, TOWER_H=134, S=TOWER_H/8, LEGAL=1.5;
    var colours=root.querySelector(".td-tw-colours"),
        names=root.querySelector(".td-tw-names"),
        legal=root.querySelector(".td-tw-legal"),
        lit=root.querySelector(".td-tw-lit"),
        cap=root.querySelector(".td-tw-cap"),
        val=root.querySelector(".td-tw-val"),
        band=root.querySelector(".td-tw-band");
    if(!colours) return;
    BANDS.forEach(function(b){
      var e=document.createElement("div"); e.className="td-tw-bnd";
      e.style.bottom=(b[0]*S)+"px"; e.style.height=((b[1]-b[0])*S)+"px";
      e.style.background=b[3]; colours.appendChild(e);
      var s=document.createElement("span"); s.textContent=b[2];
      s.style.bottom=(b[0]*S)+"px"; s.style.height=((b[1]-b[0])*S)+"px";
      names.appendChild(s);
    });
    legal.style.top=(TOP+TOWER_H-LEGAL*S-1)+"px";
    function bandFor(mm){
      for(var i=0;i<BANDS.length;i++) if(mm<BANDS[i][1]) return BANDS[i];
      return BANDS[BANDS.length-1];
    }
    var t=0;
    setInterval(function(){
      t+=0.019;
      var mm=Math.max(0.15,4.05+3.85*Math.sin(t)), b=bandFor(mm);
      lit.style.height=(mm*S)+"px";
      cap.style.bottom=(150-TOP-TOWER_H+mm*S-1)+"px";
      val.innerHTML=mm.toFixed(1)+'<s>MM</s>'; val.style.color=b[3];
      band.textContent=b[2]; band.style.color=b[3];
    },95);
  });
})();

/* ---------- RUC: climb to the licence maximum, hold, then reset ---------- */
(function(){
  /* one per card root, so the card can appear more than once */
  [].forEach.call(document.querySelectorAll(".td-ruc-scene"), function(root){
    var MIN=48200, MAX=58200, SPAN=MAX-MIN;
    var track=root.querySelector(".td-ruc-t1"), fill=root.querySelector(".td-ruc-b1"),
        flag=root.querySelector(".td-ruc-f1"), caret=root.querySelector(".td-ruc-c1"),
        num=root.querySelector(".td-ruc-n1"), km=root.querySelector(".td-ruc-k1");
    if(!track) return;
    for(var k=1;k<10;k++){
      var u=document.createElement("u"); u.style.left=(k*10)+"%"; track.appendChild(u);
    }
    function pad(n){ n=String(n); while(n.length<6) n="0"+n; return n; }
    function comma(n){ return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ","); }
    function ease(on){
      fill.style.transition  = on ? "width .12s linear,background .3s" : "none";
      flag.style.transition  = on ? "left .12s linear" : "none";
      caret.style.transition = on ? "left .12s linear" : "none";
    }
    var p=0, hold=0, jumped=false;
    ease(true);
    setInterval(function(){
      if(hold>0){
        hold--;
        if(hold===0){ ease(false); p=0; jumped=true; }
      } else {
        p+=0.0105;
        if(p>=1){ p=1; hold=14; }
      }
      var mmkm=Math.round(MIN+p*SPAN), pct=p*100, rem=MAX-mmkm;
      var hot=p>0.86, warm=p>0.68;
      fill.style.width=pct+"%";
      fill.style.background = hot  ? "linear-gradient(90deg,#c41230,#e8622c)"
                            : warm ? "linear-gradient(90deg,#e8622c,#f2c21f)"
                                   : "linear-gradient(90deg,#1fa85a,#8cc63f)";
      num.textContent=pad(mmkm); num.style.color = hot ? "#c41230" : "#0e1013";
      km.textContent = rem>0 ? comma(rem)+" KM LEFT" : "LICENCE EXPIRED";
      km.style.color = hot ? "#c41230" : "#3a4048";
      caret.style.left=pct+"%";
      var minPct=(flag.offsetWidth/track.offsetWidth)*100;
      flag.style.left=Math.max(minPct,pct)+"%";
      if(jumped){ jumped=false; fill.offsetHeight; ease(true); }
    },95);
  });
})();

/* ---------- Find Your Tyre: only play the video while it is on screen ---------- */
(function(){
  var vids=document.querySelectorAll(".td-fyt-vid, .td-fyt-scene video");
  if(!vids.length || !("IntersectionObserver" in window)) return;
  var io=new IntersectionObserver(function(es){
    es.forEach(function(e){ e.isIntersecting ? e.target.play() : e.target.pause(); });
  },{threshold:0.3});
  [].forEach.call(vids,function(v){ io.observe(v); });
})();


/* ---------- Tread patterns: cycle Taylor's three files ---------- */
(function(){
  /* one per card root, so the card can appear more than once */
  [].forEach.call(document.querySelectorAll(".td-tp-scene"), function(root){
    var imgs=root.querySelectorAll(".td-tp-pat img"),
        nm=root.querySelector(".td-tp-pnm"), ds=root.querySelector(".td-tp-pds"),
        dots=root.querySelector(".td-tp-pdots");
    if(!imgs.length||!dots) return;
    var META=[["SYMMETRIC","Same pattern both sides of the centreline. Fits either way round on the rim."],
              ["DIRECTIONAL","V grooves that only work one way. An arrow on the sidewall shows which."],
              ["ASYMMETRIC","Two different halves. The face marked OUTSIDE has to face out."]];
    META.forEach(function(_,i){
      var t=document.createElement("i"); if(i===0)t.className="td-tp-on"; dots.appendChild(t);
    });
    var pips=dots.querySelectorAll("i"), k=0;
    setInterval(function(){
      k=(k+1)%META.length;
      [].forEach.call(imgs,function(im,i){im.classList.toggle("td-tp-on",i===k)});
      [].forEach.call(pips,function(p,i){p.classList.toggle("td-tp-on",i===k)});
      if(nm) nm.textContent=META[k][0];
      if(ds) ds.textContent=META[k][1];
    },3000);
  });
})();

/* ---------- Balancer: spin, read, weight on, back to zero ---------- */
(function(){
  var TICK=95, SPIN_END=5, COAST_END=10, READ_END=23, ADD_END=35, DROP_END=56, CYCLE=78;
  var INNER=20, OUTER=10;
  [].forEach.call(document.querySelectorAll(".td-fb-scene"), function(sc){
    var img=sc.querySelector(".td-fb-w img"),
        L=sc.querySelector(".td-fb-rd.td-fb-l"), R=sc.querySelector(".td-fb-rd.td-fb-r"),
        AL=sc.querySelector(".td-fb-add.td-fb-l"), AR=sc.querySelector(".td-fb-add.td-fb-r"),
        clips=sc.querySelectorAll(".td-fb-clip"), ST=sc.querySelector(".td-fb-stat");
    if(!img||!L||!R||!ST) return;
    var ang=0, dps=0, last=null, t=-1;
    /* degrees per SECOND, not per frame, or it runs double speed on a 120Hz screen */
    (function spin(ts){
      if(last!==null){ var dt=Math.min(100,ts-last); ang=(ang+dps*dt/1000)%360;
                       img.style.transform="rotate("+ang+"deg)"; }
      last=ts; requestAnimationFrame(spin);
    })(0);
    function grams(el,v){ el.querySelector("b").innerHTML=v+'<s>g</s>';
                          el.classList.toggle("td-fb-zero", v===0); }
    function blank(el){ el.querySelector("b").innerHTML="&mdash;";
                        el.classList.remove("td-fb-zero"); }
    setInterval(function(){
      t++; if(t>=CYCLE) t=0;
      if(t===0){
        dps=760; blank(L); blank(R);
        AL.classList.remove("td-fb-go"); AR.classList.remove("td-fb-go");
        [].forEach.call(clips,function(c){ c.classList.remove("td-fb-on"); });
        ST.textContent="MEASURING"; ST.style.color="#f2c21f";
      } else if(t<SPIN_END){
      } else if(t<COAST_END){
        dps*=0.48;
      } else if(t<READ_END){
        dps=0; grams(L,INNER); grams(R,OUTER);
        ST.textContent="OUT OF BALANCE"; ST.style.color="#ff5f74";
      } else if(t===READ_END){
        void AL.offsetWidth;
        AL.classList.add("td-fb-go"); AR.classList.add("td-fb-go");
        [].forEach.call(clips,function(c){ c.classList.add("td-fb-on"); });
      } else if(t>ADD_END && t<=DROP_END){
        var f=(t-ADD_END)/(DROP_END-ADD_END);
        grams(L,Math.round(INNER*(1-f))); grams(R,Math.round(OUTER*(1-f)));
      } else if(t===DROP_END+1){
        grams(L,0); grams(R,0);
        ST.textContent="BALANCED"; ST.style.color="#4ade80";
      }
    },TICK);
  });
})();

/* ---------- 19 brands: the count, and a sweep that reads the scale ---------- */
(function(){
  var N=19;
  [].forEach.call(document.querySelectorAll(".td-brd-scene"), function(sc){
    var row=sc.querySelector(".td-brd-row"), sweep=sc.querySelector(".td-brd-sweep");
    if(!row||!sweep) return;
    for(var i=0;i<N;i++) row.appendChild(document.createElement("i"));
    var pips=row.querySelectorAll("i"), t=0, lit=-1;
    setInterval(function(){
      t=(t+1)%150;
      var f=t/120; if(f>1) f=1;
      sweep.style.left="calc(74px + (100% - 86px) * "+f.toFixed(4)+")";
      sweep.style.opacity = t<=120 ? "1" : "0";
      var k = t<=120 ? Math.min(pips.length-1, Math.floor(f*pips.length)) : -1;
      if(k!==lit){
        if(lit>-1) pips[lit].classList.remove("td-brd-lit");
        if(k>-1) pips[k].classList.add("td-brd-lit");
        lit=k;
      }
    },40);
  });
})();

/* ---------- Tyre Care: three checks, one at a time ---------- */
(function(){
  /* one per card root, so the card can appear more than once */
  [].forEach.call(document.querySelectorAll(".td-care-scene"), function(root){
    var imgs=root.querySelectorAll(".td-care-art img"),
        nm=root.querySelector(".td-care-nm"), ds=root.querySelector(".td-care-ds"),
        dots=root.querySelector(".td-care-dots");
    if(!imgs.length||!dots) return;
    var META=[["CHECK YOUR PRESSURE","All four plus the spare, checked cold."],
              ["CHECK YOUR TREAD","1.5mm is the legal minimum across the tread."],
              ["LOOK FOR DAMAGE","Cuts, bulges, and anything stuck in the tread."]];
    META.forEach(function(_,i){
      var t=document.createElement("i"); if(i===0)t.className="td-care-on"; dots.appendChild(t);
    });
    var pips=dots.querySelectorAll("i"), k=0;
    setInterval(function(){
      k=(k+1)%META.length;
      [].forEach.call(imgs,function(im,i){im.classList.toggle("td-care-on",i===k)});
      [].forEach.call(pips,function(p,i){p.classList.toggle("td-care-on",i===k)});
      if(nm) nm.textContent=META[k][0];
      if(ds) ds.textContent=META[k][1];
    },2800);
  });
})();

/* ---------- Tyre Grades: treadwear drifts, a C grade is flagged ---------- */
(function(){
  /* one per card root, so the card can appear more than once */
  [].forEach.call(document.querySelectorAll(".td-utq-scene"), function(root){
    var blocks=root.querySelectorAll(".td-utq-utb");
    if(blocks.length<3) return;
    var tw=blocks[0], tr=blocks[1], te=blocks[2];
    function marks(b){ return b.querySelectorAll(".td-utq-scaleline s"); }
    function light(b,i){
      var m=marks(b);
      for(var j=0;j<m.length;j++) m[j].classList.toggle("td-utq-on", j===i);
    }
    function grade(b,txt){
      var v=b.querySelector("b");
      v.textContent=txt;
      /* only C is flagged. B is a perfectly ordinary grade and colouring it
         amber would be inventing a warning the page does not make. */
      v.classList.toggle("td-utq-bad", txt==="C");
    }
    var TR=["AA","A","B","C"], TE=["A","B","C"], t=0, ti=1, ei=0;
    setInterval(function(){
      t+=0.055;
      var v=Math.round((450+140*Math.sin(t)+35*Math.sin(t*2.7))/10)*10;
      v=Math.max(300,Math.min(600,v));
      tw.querySelector("b").textContent=v;
      var m=marks(tw), best=0, bd=1e9;
      for(var j=0;j<m.length;j++){
        var d=Math.abs(parseInt(m[j].textContent,10)-v);
        if(d<bd){ bd=d; best=j; }
      }
      light(tw,best);
    },110);
    setInterval(function(){ ti=(ti+1)%TR.length; grade(tr,TR[ti]); light(tr,ti); },1700);
    setInterval(function(){ ei=(ei+1)%TE.length; grade(te,TE[ei]); light(te,ei); },2300);
  });
})();

/* ---------- How to Buy: each step takes its turn ---------- */
(function(){
  /* one per card root, so the card can appear more than once */
  [].forEach.call(document.querySelectorAll(".td-buy-scene"), function(root){
    var steps=root.querySelectorAll(".td-buy-step");
    if(!steps.length) return;
    var k=-1;
    setInterval(function(){
      k=(k+1)%steps.length;
      for(var i=0;i<steps.length;i++) steps[i].classList.toggle("td-buy-on", i===k);
    },1500);
  });
})();

/* ---------- Camping: sparks off the fire ---------- */
(function(){
  [].forEach.call(document.querySelectorAll(".td-camp-sc"), function(root){
    var fire=root.querySelector(".td-camp-c1fire"); if(!fire) return;
    [[-10,0],[4,-0.5],[-2,-0.9],[10,-1.25],[-14,-1.5],[7,-1.9]].forEach(function(s,i){
      var k=document.createElement("span"); k.className="td-camp-spark";
      k.style.marginLeft=s[0]+"px";
      k.style.setProperty("--dx",(s[0]<0?-9:10)+"px");
      k.style.animationDelay=s[1]+"s";
      k.style.animationDuration=(1.4+i*0.15).toFixed(2)+"s";
      fire.appendChild(k);
    });
  });
})();

/* ---------- Wet road and beach: rain, spray, sand ---------- */
(function(){
  var REFL = 0;
  function reid(root, tag){
    [].forEach.call(root.querySelectorAll("[id]"), function(el){
      var was = el.id, now = was + "-" + tag;
      el.id = now;
      [].forEach.call(root.querySelectorAll("*"), function(u){
        for(var i=0;i<u.attributes.length;i++){
          var a = u.attributes[i];
          if(a.value === "url(#" + was + ")") a.value = "url(#" + now + ")";
          else if(a.value === "#" + was) a.value = "#" + now;
        }
      });
    });
  }
  [].forEach.call(document.querySelectorAll(".td-wx-scene"), function(sc){
    /* the reflection is the same drawing flipped. cloning it here rather than
       shipping the svg twice saves about 5KB a card. */
    var car = sc.querySelector(".td-wx-car svg"),
        refl = sc.querySelector(".td-wx-refl");
    if(car && refl && !refl.firstElementChild){
      var c = car.cloneNode(true);
      /* the clone carries the original's ids, so with more than one car card on
         a page every clipPath and gradient id exists several times over and
         url(#id) resolves to whichever came first. Identical defs made that
         harmless and invisible; a car in a different colour would not be. Give
         the clone its own namespace on the way in. */
      reid(c, "r" + (++REFL));
      refl.appendChild(c);
    }
    var sand = sc.classList.contains("td-wx-sand");
    var rear = parseFloat(sc.dataset.rear), front = parseFloat(sc.dataset.front),
        axle = parseFloat(sc.dataset.axle);
    if(!sand){
      for(var i=0;i<38;i++){
        var d=document.createElement("span"); d.className="td-wx-rain";
        d.style.left=(-12+i*9+(i%7)*3)+"px";
        d.style.height=(8+(i%5)*5)+"px";
        d.style.animationDuration=(0.38+(i%4)*0.06).toFixed(2)+"s";
        d.style.animationDelay=(-(i*0.031)).toFixed(3)+"s";
        d.style.opacity=(0.24+((i%5)*0.15)).toFixed(2);
        sc.appendChild(d);
      }
      [[rear,0],[rear,-0.16],[front,-0.28],[front,-0.4]].forEach(function(s){
        var p=document.createElement("span"); p.className="td-wx-sp";
        p.style.left=(s[0]-6)+"px"; p.style.top=(axle+4)+"px";
        p.style.width="15px"; p.style.animationDelay=s[1]+"s";
        sc.appendChild(p);
      });
    } else {
      [[rear+2,0],[rear-3,-0.18],[rear+6,-0.3],[front,-0.42],[front-5,-0.6]]
      .forEach(function(s){
        var k=document.createElement("span"); k.className="td-wx-kick";
        k.style.left=s[0]+"px"; k.style.top=(axle+6)+"px";
        k.style.animationDelay=s[1]+"s";
        sc.appendChild(k);
      });
    }
  });
})();

/* ---------- Cheap Tyres: it bounces, the price falls ---------- */
(function(){
  /* one per card root, so the card can appear more than once */
  [].forEach.call(document.querySelectorAll(".td-ct-scene"), function(root){
  var PRICES = ["$210","$175","$140","$105","$70"], FLOOR = 3;
    var tyre = root.querySelector(".cttyre"),
        p = root.querySelector(".ctp"),
        old = root.querySelector(".ctold");
    if(!tyre || !p || !old) return;
    var k = 0;
    /* fire off the animation itself so the price always changes as it lands */
    tyre.addEventListener("animationiteration", function(){
      var was = PRICES[k];
      k = (k + 1) % PRICES.length;
      old.innerHTML = "<s>" + was + "</s>";
      old.classList.remove("td-ct-go"); void old.offsetWidth; old.classList.add("td-ct-go");
      p.textContent = PRICES[k];
      p.classList.toggle("td-ct-floor", k >= FLOOR);
    });
  });
})();

/* ---------- Following distance: the seconds readout ---------- */
(function(){
  [].forEach.call(document.querySelectorAll(".td-wx-follow"), function(sc){
    var out = sc.querySelector(".td-fd-secs"),
        say = sc.querySelector(".td-fd-verdict b");
    if(!out) return;
    /* the number is driven off the same clock as the keyframes rather than its
       own timer, so the readout cannot drift away from the car it describes. */
    var T = 7000, t0 = null;
    function frame(ts){
      if(t0 === null) t0 = ts;
      var p = ((ts - t0) % T) / T, s;
      if(p < 0.17) s = 2;
      else if(p < 0.40) s = 2 + (p - 0.17) / 0.23 * 2;
      else if(p < 0.88) s = 4;
      else s = 4 - (p - 0.88) / 0.12 * 2;
      out.textContent = s.toFixed(1);
      say.textContent = s < 3 ? "TOO CLOSE" : "SAFE GAP";
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  });
})();






